module.exports = __webpack_public_path__ + "static/img/case_top.f5a64af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_top.png
// module id = pofQ
// module chunks = 1